<div>
  <mat-card *ngIf="employee">
    <mat-card-content *ngIf="vm">
      <p>{{employee.firstName + ' ' + employee.lastName}}</p>
      <h4>Drivers</h4>
      <p *ngFor="let driver of vm.drivers">{{driver.firstName + ' ' + driver.lastName}}</p>
    </mat-card-content>
  </mat-card>
</div>